//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQToast from "../../../../../components/Generics/AQToast/AQToast.vue";
import AQButton from "../../../../../components/Generics/AQButton/AQButton.vue";

export default {
    name: "ViewAQToast",
    components: {
        AQButton,
        AQToast
    },
    data() {
        return {
            displayToast1: false,
            displayToast2: false,
            displayToast3: false,
            displayToast4: false,
            displayToast5: false,
            displayToast6: false,
            displayToast7: false,
            displayToast8: false,
            displayToast9: false,
            displayToast10: false,
            displayToast11: false,
            displayToast12: false,
            displayToast13: false,
            displayToast14: false,
            displayToast15: false,
            displayToast16: false,
            displayToast17: false,
            displayToast18: false,
            displayToast19: false,
            displayToast20: false,
            titleText: "Info alert",
            mainText: "Nulla ad adipisicing adipisicing mollit qui proident veniam ullamco adipisicing.",
            singleLineMessage: "This is a simple info alert on a single line",
            twoLinesMessage: "This is a simple info alert on two lines when we have a lot of text."
        };
    },
    methods: {
        myCustomAction() {
            alert("This is a toast action button test. Enjoy");
        },
        showNewToast() {
            this.$q.notify({
                message: "Jim pinged you.",
                color: "purple"
            });
        },
        showNotification() {
            this.$toast.showNotify({
                message: this.singleLineMessage,
                timeout: 30000000,
                type: "info",
                closeEvent: this.myCustomAction
            });
        },
        showToast() {
            this.$toast.showNotify({
                message: this.twoLinesMessage,
                buttonLabel: "Button",
                timeout: 30000000,
                actionEvent: this.myCustomAction
            });
        }
    }
};

